module.exports = __webpack_public_path__ + "img/5.87bff88f.png";